// extracted by mini-css-extract-plugin
export var actionButton = "_k3-t";
export var buttonContainer = "_k3-0";
export var buttonContainer2 = "_k3-1";
export var buttonSection = "_k3-2";
export var details = "_k3-3";
export var dropdownItem = "_k3-5";
export var dropdownItemsContainer = "_k3-4";
export var fileInput = "_k3-r";
export var headerButton = "_k3-6";
export var icon = "_k3-7";
export var input = "_k3-8";
export var macroListItem = "_k3-9";
export var mainContent = "_k3-a";
export var microText = "_k3-b";
export var modal = "_k3-w";
export var optionsButton = "_k3-c";
export var paperclip = "_k3-s";
export var pillContent = "_k3-d";
export var preview = "_k3-e";
export var preview2 = "_k3-f";
export var quillEditor = "_k3-q";
export var selectedMacro = "_k3-g";
export var sidebar = "_k3-h";
export var sidebarHeader = "_k3-j";
export var sidebarList = "_k3-i";
export var sidebarListItem = "_k3-k";
export var sidebarSearch = "_k3-l";
export var snoozeDurationWrapper = "_k3-v";
export var statusPillContainer = "_k3-m";
export var tagsContainer = "_k3-n";
export var unselectedMacro = "_k3-o";
export var variable = "_k3-u";
export var wrapper = "_k3-p";